// paquetes
import {useLocation,  useParams, useNavigate, useOutletContext} from 'react-router-dom';
import React, {useState, useEffect, useRef  } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
// componentes
import ZonaCargando from '../../alertas/zonaCargando';
import CardAyudarACrear from '../../../componentesEspeciales/cardAyudarAcrear';
import BotonVerificar from '../../../componentesEspeciales/cuenta/botonVerificar';
// estilos
import '../../../estilos/usuario.css';



function Dasboard() {
    const { usuario, setUsuario, cargandoUsuario } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const navigate                      = useNavigate();
    
    // Variables
    const [cargando, setCargando]    = useState(false);
    const [dashboard, setDashboard]  = useState({
        serviciosActivos: 0,
        serviciosBorrador: 0,
        saldoPendiente: 0,
        reservasPendientesDePago: 0,
    });
    const cargandoFinal              = Boolean(cargandoUsuario) || Boolean(cargando);


    useEffect(() => {
        (async () => {
            if (cargandoUsuario) return; // Espera a que Direccionamiento termine de cargar sesión

            // Si no hay usuario, esta página requiere login
            if (!usuario) { return navigate("/iniciar-sesion"); }

            // Hidratamos el perfil desde el usuario global
            try {
                setCargando(true);
                const resUsuario = await axios.post("/obtener-dashboard", {
                    params: { quienEs: "Vendedor", idUsuario: usuario.idUsuario }
                });

                const dataDashboard = resUsuario?.data?.dashboard || {};

                setDashboard({
                    serviciosActivos: Number(dataDashboard.serviciosActivos || 0),
                    serviciosBorrador: Number(dataDashboard.serviciosBorrador || 0),
                    saldoPendiente: Number(dataDashboard.saldoPendiente || 0),
                    reservasPendientesDePago: Number(dataDashboard.reservasPendientesDePago || 0),
                });
            }
            finally {
                setCargando(false);
            }
        })();
    }, [usuario, cargandoUsuario]);

    const formatoCOP = (valor) => {
        const numero = Number(valor || 0);

        return new Intl.NumberFormat("es-CO", {
            style: "currency",
            currency: "COP",
            maximumFractionDigits: 0,
        }).format(numero);
    };
    








    return(
    <div >
    { (cargandoFinal) ? <ZonaCargando />
    :  usuario ? 
    <div className='d-flex flex-row '>
        {/* Columna 2 */}
        <div className="flex-grow-1 container-fluid contenedorAdaptador ">     
            {/* Contenedor título  */}
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom border-dark">
                <div className="container">
                    <div className="d-flex justify-content-between align-items-center flex-wrap">
                        {/* título */}
                        <h1 className="h2 text-dark mb-0">Dashboard</h1>
                    </div>
                </div>
            </div>

            <div className="container mb-4">
                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "22px" }}>
                    <div className="card-body p-4">
                        <div className="mb-4">
                            <span className="badge rounded-pill text-bg-primary px-3 py-2 mb-2">Panel de vendedor</span>
                            <h2 className="h4 fw-bold text-dark mb-1">Tu negocio</h2>
                            <p className="text-muted mb-0">Aquí puedes ver un resumen rápido de tu actividad en Zervicy.</p>
                        </div>

                        <div className="row g-3">
                            <div className="col-12 col-md-4">
                                <div className="h-100 p-3 rounded-4 bg-light">
                                    <p className="text-muted mb-2 fw-semibold">Activos</p>
                                    <h3 className="fw-bold mb-0 text-dark">{dashboard.serviciosActivos}</h3>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="h-100 p-3 rounded-4 bg-light">
                                    <p className="text-muted mb-2 fw-semibold">Borradores</p>
                                    <h3 className="fw-bold mb-0 text-dark">{dashboard.serviciosBorrador}</h3>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="h-100 p-3 rounded-4 bg-light">
                                    <p className="text-muted mb-2 fw-semibold">Saldo</p>
                                    <h3 className="fw-bold mb-0 text-dark">{formatoCOP(dashboard.saldoPendiente)}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {(dashboard.serviciosBorrador > 0 || dashboard.serviciosActivos === 0) && (
                    <CardAyudarACrear className="mb-4" usuarioId={usuario?.idUsuario} />
                )}

                <div className="card border-0 shadow-sm mb-4" style={{ borderRadius: "22px" }}>
                    <div className="card-body p-4">
                        <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-3">
                            <div>
                                <h3 className="h5 fw-bold text-dark mb-1">Acciones rápidas</h3>
                                <p className="text-muted mb-0">Accede rápido a las zonas principales de tu cuenta.</p>
                            </div>
                        </div>

                        <BotonVerificar usuario={usuario} setUsuario={setUsuario} className="mb-3" />

                        <div className="row g-3">
                            <div className="col-12 col-md-6 col-xl-3">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100 py-3 rounded-4 fw-semibold d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => navigate("/vendedor/mi-cuenta")}
                                >
                                    <i className="bi bi-person-fill"></i>
                                    Editar perfil
                                </button>
                            </div>

                            <div className="col-12 col-md-6 col-xl-3">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100 py-3 rounded-4 fw-semibold d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => navigate("/vendedor/servicios")}
                                >
                                    <i className="bi bi-briefcase-fill"></i>
                                    Mis servicios
                                </button>
                            </div>

                            <div className="col-12 col-md-6 col-xl-3">
                                <button
                                    type="button"
                                    className="btn btn-primary w-100 py-3 rounded-4 fw-semibold d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => navigate("/vendedor/crear-editar-servicio")}
                                >
                                    <i className="bi bi-plus-circle-fill"></i>
                                    Crear servicio
                                </button>
                            </div>

                            <div className="col-12 col-md-6 col-xl-3">
                                <button
                                    type="button"
                                    className="btn btn-outline-primary w-100 py-3 rounded-4 fw-semibold d-flex align-items-center justify-content-center gap-2"
                                    onClick={() => navigate("/vendedor/gestionar-reservas")}
                                >
                                    <i className="bi bi-calendar-check-fill"></i>
                                    Reservas
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card border-0 shadow-sm" style={{ borderRadius: "22px" }}>
                    <div className="card-body p-4">
                        <div className="mb-3">
                            <h3 className="h5 fw-bold text-dark mb-1">Video explicativo</h3>
                            <p className="text-muted mb-0">Mira este video para conocer mejor tu panel de vendedor.</p>
                        </div>

                        <div className="ratio ratio-16x9 rounded-4 overflow-hidden">
                            <iframe
                                src="https://www.youtube.com/embed/veBkPx1yUkc?rel=0"
                                title="Video explicativo dashboard vendedor"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allowFullScreen
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    : null
    }
    </div>  
    )
}
  
  
  
export default Dasboard;